import {
  Box, FormControl, InputLabel, MenuItem, Select,
} from '@mui/material';
import { useGetRegionsQuery } from '../../core/redux/webshop';

export const RegionSelect = ({
  disabled = false,
  region,
  setRegion = () => null,
  orderType,
  isUrgent,
}: {
  disabled?: boolean;
  region: number;
  setRegion: (id: number) => void;
  orderType?: 'Clothing' | 'Equipment';
  isUrgent?: boolean;
}) => {
  const { data: regions } = useGetRegionsQuery();

  const filteredRegions = orderType
    ? regions?.filter((r) => r.pickupInfo?.some(
      (p) => p.orderType === orderType && p.isUrgent === isUrgent,
    ))
    : regions;

  return (
    <Box sx={{ minWidth: '15rem' }}>
      <FormControl fullWidth>
        <InputLabel id="region-select-label">Leveringssted</InputLabel>
        <Select
          aria-labelledby="region-select-label"
          name="region-select"
          value={region.toString()}
          label="Leveringssted"
          onChange={(v) => setRegion(parseInt(v.target.value, 10))}
          disabled={disabled}
        >
          {filteredRegions
            && filteredRegions.map((r) => (
              <MenuItem value={r.id}>{r.name}</MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
};
